
class formUTMs {
    
    constructor() {
        this.populateUTMs();
    }
    
    populateUTMs() {
        const formUTMsObj = this;
        let pageForm = jQuery('form');
        
        if(pageForm.length != 0) {
            let fieldPrefix = '';
            
            if(pageForm.find('#form-field-utm_source').length != 0) { // Elementor Form
                fieldPrefix = 'form-field-';
            }
            setTimeout(() => {
                let foundUTMs = setInterval(function () {
                    let UTMs = formUTMsObj.getUTMs();

                    if(UTMs != null) {
                        jQuery.each(UTMs, function (index, UTM) {
                            if(jQuery('input[id="'+fieldPrefix+index+'"]').length > 0) {
                                jQuery('input[id="'+fieldPrefix+index+'"]').each(function () {
                                    jQuery(this).val(UTM);
                                });
                            }
                        });
                        clearInterval(foundUTMs);
                    }
                }, 500);
            }, 5000);
        }
    }
    
    getUTMs() {
        let UTMs = {};
        let cookieValue = this.getCookie('__gtm_campaign_url', null);
        
        if(cookieValue == null) {
            cookieValue = this.getCookie('__gtm_referrer', null);
        }
        
        if(cookieValue != null && cookieValue != '') {
            cookieValue = decodeURIComponent(cookieValue);
            UTMs['gtm_campaign_url'] = cookieValue;
            
            cookieValue.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
                UTMs[key] = value;
            });
            
            return UTMs;
        } else {
            return null;
        }
    }
    
    getCookie(name, defaultVal) {
        let nameEQ = name + "=",
            ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
    
        return defaultVal === undefined ? null : defaultVal;
    }
}

jQuery(document).ready(function () {
    new formUTMs();
});